import { useState, useRef } from 'react';
import './import_export.scss'
import { __ } from '@wordpress/i18n';
import nxtds_icons from '../../dashIcon';
import ProNotice from '../pro-model/pro-notice'

var activateTheme = nxtext_ajax_object?.dashData?.nexterThemeActive || false;

var import_export_list = [];

// Push 'customizer-import-export' only if theme is active


// Always push 'extension-import-export'
if(nxtext_ajax_object?.dashData?.extensioninstall){
if (activateTheme) {
    import_export_list.push({
        key: 'customizer-import-export',
        name: __('Import/Export Theme Customizer Settings', 'nexter-extension'),
        crd_desc: __('Easily import or export Nexter Theme Customizer settings to use across different sites.', 'nexter-extension'),
        popDesc: __('Easily import or export Nexter Theme Customizer settings to use across different sites.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/import-export-nexter-theme-customizer-settings/",
        formField: { key: 'customizer-import-export', label: __('Import/Export Theme Customizer Settings', 'nexter-extension') },
    });
}
    import_export_list.push({
        key: 'extension-import-export',
        name: __('Import/Export Extension Settings', 'nexter-extension'),
        crd_desc: __('Easily import or export Nexter Extension settings to use across different sites.', 'nexter-extension'),
        popDesc: __('Easily import or export Nexter Extension settings to use across different sites.', 'nexter-extension'),
        read_link: "https://nexterwp.com/docs/import-export-nexter-extension-settings/",
        formField: { key: 'extension-import-export', label: __('Import/Export Extension Settings', 'nexter-extension') },
        isPro : true,
    });
}
const CodeOptions = () => {

    const [customizerFile, setcustomizerFile] = useState(null);
    const [fileName, setFileName] = useState('--Choose File--');

    const [extType, setExtType] = useState('');
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [isPopupProVisible, setIsPopupProVisible] = useState(false);
    const [popupData, setPopupData] = useState(null);
    const [message, setMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [isProcess, setProcess] = useState('');
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setcustomizerFile(file)
        setFileName(file ? file.name : '--Choose File--');
    };

    const nxtImportData = (e, type) => {
        e.preventDefault();

        if (!type || !customizerFile) {
            setMessage('Please select a file to import.');
            setIsError(true);
            return;
        }

        const formData = new FormData();
        if(type==='nxt_import_ext'){
            formData.append('action', 'nxt_import_extension_data');
            formData.append('nexter_import_ext_nonce', nxtext_ajax_object?.ajax_nonce); // nonce field
        }else{
            formData.append('action', 'nxt_import_customizer_data');
            formData.append('nexter_import_cust_nonce', nxtext_ajax_object?.ajax_nonce); // nonce field
        }
        formData.append('nxt_import_file', customizerFile);
        

        setMessage('');
        setIsError(false);
        setProcess('Importing')
        fetch(nxtext_ajax_object?.ajax_url, {
            method: 'POST',
            body: formData,
        })
        .then(res => res.json())
        .then(response => {
            if (response.success) {
                setMessage(response.data || 'Import successful!');
                setIsError(false);
                setcustomizerFile(null); // optional: reset file input
                setFileName('--Choose File--');
                if (fileInputRef.current) fileInputRef.current.value = '';
                setProcess('Imported')
                setTimeout(() => {
                    setMessage('');
                    setProcess('Import')
                }, 2500);
            } else {
                setMessage(response.data || 'Import failed.');
                setIsError(true);
                setProcess('Import')
            }
        })
        .catch(() => {
            setMessage('An error occurred during import.');
            setIsError(true);
            setProcess('Import')
        });
    };
   
    const handleOpenPopup = (data) => {
        setcustomizerFile(null);
        setFileName('--Choose File--');
        setExtType(data.key)
        setPopupData(data);
        setIsPopupVisible(true);
    };

    const handleClosePopup = () => {
        setIsPopupVisible(false);
        setPopupData(null);
    };

    const tooltipSVG = <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.48 7A5.48 5.48 0 1 1 1.52 7 5.48 5.48 0 0 1 12.48 7z" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 9.333V7" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /><path d="M7 4.666h.006" stroke="#1A1A1A" strokeWidth="0.705882" strokeLinecap="round" strokeLinejoin="round" /></svg>

    return (
        <>
            <div className='nxtext_theme_ctm_inn_main nxtext_main_container'>
                <div className='nxtext_section_heading_cover'>
                    <h3 className='nxtext_primary_heading'>{__('Nexter Import/Export Data', 'nexter-extension')}</h3>
                </div>
                <div className='nxtext_theme_cstm_crds_cover'>
                    {import_export_list.map((item) => (
                        <div className='nxtext_field_card' key={item.name}>
                            <div className='nxtext_card_top_detail'>
                                <div className='nxtext_field_card_h_strip'>
                                    <div className='nxtext_excrd_h_cover'>
                                        <h4 className='nxtext_secondary_heading'>{item.name}</h4>
                                        <div className="nxt-new-ext">{ __( "NEW", 'nexter-extension' ) }</div>
                                        <div className='nxtext_tooltip'>{tooltipSVG}
                                            <span className="nxtext_tooltiptext">{item.crd_desc}</span>
                                        </div>
                                    </div>
                                    <div className='nxtext-extra-tgl-wrap'>
                                        <button className={'nxtext_ex_btn enabled'} onClick={() => { if (!nxtext_ajax_object.pro && item.isPro) { setIsPopupProVisible(prev => !prev)}else{ handleOpenPopup(item) } }}>{nxtds_icons.setting}</button>
                                    </div>
                                </div>
                                {item.read_link && !((nxtext_ajax_object.pro || nxtext_ajax_object.tpgb_pro) && nxtext_ajax_object?.dashData?.whiteLabel?.nxt_help_link == 'on') &&
                                    <div className='nxtext_links_cover'>
                                        <a target="_blank" rel="noopener noreferrer" href={item.read_link || '#'} className='nxtext_tertiary_btn nxtext_paragraph'>{__('Read Docs', 'nexter-extension')}</a>
                                    </div>
                                }
                            </div>
                            {!nxtext_ajax_object.pro && item.isPro &&
                                <div className="nxt-beta-ext">{ __( "PRO", 'nexter-extension' ) }</div>
                            }
                        </div>
                    ))}
                </div>
                {isPopupVisible &&
                <div>
                    <>
                        <div className='nxtext_overlay' onClick={handleClosePopup}></div>
                        <div className={`nxtext_settings_popup ${extType}-popup`}>
                        <svg className='nxtext_close_icon' draggable={false} onClick={handleClosePopup} xmlns="http://www.w3.org/2000/svg" width="36" height="17" fill="none" viewBox="0 0 36 17"><path fill="#414B5A" d="M22.2 4.30665c-.26-.26-.68-.26-.94 0L18 7.55998l-3.26-3.26c-.26-.26-.68-.26-.94 0-.26.26-.26.68 0 .94l3.26 3.26L13.8 11.76c-.26.26-.26.68 0 .94.26.26.68.26.94 0L18 9.43998 21.26 12.7c.26.26.68.26.94 0 .26-.26.26-.68 0-.94l-3.26-3.26002 3.26-3.26c.2533-.25333.2533-.68 0-.93333Z"/></svg>

                            <div className='nxtext_popup_heading'>
                                <h3 className='nxtext_primary_heading'>{popupData.name}</h3>
                                <p className='nxtext_paragrph' dangerouslySetInnerHTML={{ __html: popupData.popDesc }}></p>

                            </div>
                            <div className='nxtext_popup_inner_main_co'>
                                {Object.keys(popupData.formField).map((key) => {
                                    const field = popupData.formField[key];
                                    if(key == 'label'){
                                        return
                                    }
                                    return (

                                        <div className='nxtext_field_card_cover' key={key} id={field}>
                                            <div className='nxtext_crd_head_strip'>
                                                <label htmlFor={key} className='nxtext_secondary_heading'>{field.label}</label>
                                            </div>
                                            <div className='nxtext_perfmnce_crds_maincover'>
                                                {/* Theme Customizer */}
                                                {field === 'customizer-import-export' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        <div className="nxtext_strip_tgl_cover nxtext_full_strip_tgl nxt-export-wrap">
                                                            <div className='nxtext_strip_tgl_h'>
                                                                <label className='nxtext_paragrph' htmlFor={"customizer-export"}>{__("Export Customizer Settings", 'nexter-extension')}</label>
                                                            </div>
                                                            <div className='nxtext_tgl_with_setting'>
                                                                <form method="post">
                                                                    <input type="hidden" name="nxt_customizer_export_action" value="nxt_export_cust" />
                                                                    <input type="hidden" id="nexter_export_cust_nonce" name="nexter_export_cust_nonce" value={nxtext_ajax_object?.ajax_nonce}></input>
                                                                    <button className="nxtext_primary_btn nxt-export-btn" >{__('Export', 'nexter-extension')}</button>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div className="nxtext_strip_tgl_cover nxtext_full_strip_tgl nxt-export-wrap">
                                                            <form className="nxt-import-form-data" onSubmit={(e) => nxtImportData(e, 'nxt_import_cust')} encType="multipart/form-data">
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={"customizer-export"}>{__("Import Customizer Settings", 'nexter-extension')}</label>
                                                                </div>
                                                                <div className={"custom-file-wrapper"+(customizerFile !=null ? ' active-choose-file' : '')}>
                                                                    <label htmlFor="customFileInput" className="custom-file-button"><span className={"custom-file-label"+(customizerFile !=null ? ' active-choose-file' : '')}>{fileName}</span>
                                                                        {__('Choose File', 'nexter-extension')}
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        id="customFileInput"
                                                                        name="nxt_import_file"
                                                                        className="custom-file-input"
                                                                        onChange={(e) => handleFileChange(e)}
                                                                        ref={fileInputRef}
                                                                        required
                                                                    />
                                                                </div>
                                                                <button type="submit" className="nxtext_primary_btn nxt-import-btn">{isProcess ? isProcess : __('Import', 'nexter-extension')}</button>
                                                            </form>
                                                        </div>
                                                        {message && (
                                                            <div className={isError ? 'nxt-ext-error-message' : 'nxt-ext-success-message'}>
                                                                {message}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {/* Theme Customizer */}
                                                {/* Nexter Extension */}
                                                {field === 'extension-import-export' && (
                                                    <div className='nxtext_pop_in_cover'>
                                                        <div className="nxtext_strip_tgl_cover nxtext_full_strip_tgl nxt-export-wrap">
                                                            <div className='nxtext_strip_tgl_h'>
                                                                <label className='nxtext_paragrph' htmlFor={"extension-export"}>{__("Export Extension Settings", 'nexter-extension')}</label>
                                                            </div>
                                                            <div className='nxtext_tgl_with_setting'>
                                                                <form method="post">
                                                                    <input type="hidden" name="nxt_extension_export_action" value="nxt_export_ext" />
                                                                    <input type="hidden" id="nexter_export_ext_nonce" name="nexter_export_ext_nonce" value={nxtext_ajax_object?.ajax_nonce}></input>
                                                                    <button className="nxtext_primary_btn nxt-export-btn" >{__('Export', 'nexter-extension')}</button>
                                                                </form>
                                                            </div>
                                                        </div>
                                                        <div className="nxtext_strip_tgl_cover nxtext_full_strip_tgl nxt-export-wrap">
                                                            <form className="nxt-import-form-data" onSubmit={(e) => nxtImportData(e, 'nxt_import_ext')} encType="multipart/form-data">
                                                                <div className='nxtext_strip_tgl_h'>
                                                                    <label className='nxtext_paragrph' htmlFor={"extension-export"}>{__("Import Extension Settings", 'nexter-extension')}</label>
                                                                </div>
                                                                <div className="custom-file-wrapper">
                                                                    
                                                                    <label htmlFor="customFileInput" className="custom-file-button">
                                                                        <span className={"custom-file-label"+(customizerFile !=null ? ' active-choose-file' : '')}>{fileName}</span>
                                                                        {__('Choose File', 'nexter-extension')}
                                                                    </label>
                                                                    <input
                                                                        type="file"
                                                                        id="customFileInput"
                                                                        name="nxt_import_file"
                                                                        className="custom-file-input"
                                                                        onChange={(e) => handleFileChange(e)}
                                                                        ref={fileInputRef}
                                                                        required
                                                                    />
                                                                </div>
                                                                <button type="submit" className="nxtext_primary_btn nxt-import-btn">{isProcess ? isProcess : __('Import', 'nexter-extension')}</button>
                                                            </form>
                                                        </div>
                                                        {message && (
                                                            <div className={isError ? 'nxt-ext-error-message' : 'nxt-ext-success-message'}>
                                                                {message}
                                                            </div>
                                                        )}
                                                    </div>
                                                )}
                                                {/* Nexter Extension */}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>

                            <div className='nxtext_popup_bottom'>
                                {popupData.read_link &&
                                    <a className='nxtext_tertiary_btn' target="_blank" rel="noopener noreferrer" href={popupData.read_link}>{__('Read How it Works', 'nexter-extension')}</a>
                                }
                               {/*  <button className="nxtext_blue_common_btn" onClick={handlePopupSave}>{__('Save', 'nexter-extension')}</button> */}
                            </div>
                        </div>
                    </>
                </div>
            }
            {isPopupProVisible &&
                <ProNotice isPopupVisible={isPopupProVisible} setIsPopupVisible={setIsPopupProVisible} />
            }
            </div>
        </>

    )
}


export default CodeOptions;